import { Pipe, PipeTransform } from '@angular/core'
import { Profile } from '../interfaces/user'
import { LocaleService } from '../services/locale/locale-service'
/**
 * 반올림 pipe
 */
@Pipe({
  name: 'name',
})
export class NamePipe implements PipeTransform {
  constructor(private localeService: LocaleService) { }


  transform(value?: Profile, emptyValue: string = '', suffix: string = ''): string {
    if (value?.firstName) {
      return this.localeService.getLocaleName(value.firstName, value.lastName) + suffix
    }
    return emptyValue
  }
}
